import React from "react";
import Classes from "./styles/style.module.css";
import getProfileImage from "../../../assets/Hooks/getProfileImage";
import { useNavigate } from "react-router-dom";

const UserListElement = ({ score, rate, name, profile, id, type }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (id) {
      navigate(`/scoreHistory/${id}?order=${type}`);
    } else {
      navigate(`/scoreHistory`);
    }
  };

  return (
    <div className={Classes.userListElement} onClick={handleClick}>
      <div className="d-flex justify-content-between align-items-center">
        <div className={Classes.AvatarRate}>{getProfileImage(profile)}</div>
        <div>
          <p className={Classes.userName}> {name}</p>
          <p className={Classes.rateText}>{`رتبه ${rate}`}</p>
        </div>
      </div>
      <p className={Classes.rate}>{score}</p>
    </div>
  );
};

export default UserListElement;
